"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addBackorderDemandHandler = addBackorderDemandHandler;
var _addBackorderDemandFailed = require("@ori-events/add-backorder-demand-failed");
var _types = require("../types");
var _utils = require("../utils");
async function addBackorderDemandHandler({
  detail: {
    lineNumber,
    placement,
    quantity
  }
}) {
  if (typeof quantity === 'number' && quantity > 0) {
    const responseWithQuantity = await fetch(`${_types.RequestUrl.UpdateBasketItem}?lineNumber=${lineNumber}&quantity=${quantity}`, (0, _utils.getHttpRequestSettings)({
      placement
    }));
    const dataWithQuantity = (0, _utils.convertToCamelCase)(await responseWithQuantity.json());
    if ((0, _addBackorderDemandFailed.isAddBackorderDemandErrorResponse)(dataWithQuantity)) {
      const errorEvent = new CustomEvent(_addBackorderDemandFailed.Name, {
        detail: dataWithQuantity
      });
      window.dispatchEvent(errorEvent);
      return false;
    }
  }
  const response = await fetch(`${_types.RequestUrl.AddBackorderDemand}?lineNumber=${lineNumber}`, (0, _utils.getHttpRequestSettings)());
  const data = (0, _utils.convertToCamelCase)(await response.json());
  if ((0, _addBackorderDemandFailed.isAddBackorderDemandErrorResponse)(data)) {
    const errorEvent = new CustomEvent(_addBackorderDemandFailed.Name, {
      detail: data
    });
    window.dispatchEvent(errorEvent);
    return false;
  }
  return data;
}